import React from 'react';
import { motion } from 'framer-motion';

export default function GlassCard({ children, className = '', delay = 0, hover = true, ...props }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94], delay }}
      viewport={{ once: true, margin: '-15%' }}
      className={`relative rounded-2xl border border-[rgba(255,255,255,0.06)] bg-[rgba(255,255,255,0.03)] backdrop-blur-xl transition-all duration-300 ${hover ? 'hover:border-[rgba(0,212,255,0.25)] hover:shadow-[0_8px_40px_rgba(0,212,255,0.12)] hover:-translate-y-1.5' : ''} ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
}
